import { fromJS, List, Map } from '@gonfalon/immutable-shim/immutableShim';

import { CodeStatisticsForFlag } from './records/CodeStatisticsForFlag';
import { type Repository } from './records/Repository';

export function createCodeStatistics(props = List<Repository>()) {
  if (props.size > 0) {
    return props.map((stat) => new CodeStatisticsForFlag(fromJS(stat)));
  }
  return Map();
}
